import $ from 'jquery';

export function HookForms() {
  function buttons() {
    // Skip Validation for certain buttons
    $(
      'button[name="checkout2_add"],button[name="checkout2_remove"],button[name="checkout2_update"],button[data-skip-valid]',
    )
      .off('click')
      .click(() => {
        $('form[name=checkout2]').attr('novalidate', 'novalidate');
        $('[required]').attr('required', 'required');
      });
  }

  function radioValue() {
    $('input[data-radio-value]').each(function () {
      const $this = $(this);
      if ($this.attr('data-radio-value') === $this.attr('value')) {
        $this.prop('checked', true);
      }
    });
  }

  function selectValue() {
    $('select[data-select-value]').each(function () {
      const $this = $(this);
      const v = $this.attr('value');
      const $byVal = $this.find('option[value~="' + v + '"]');
      if ($byVal.length > 0) {
        $this.val($byVal.attr('value'));
      } else {
        const $byBody = $this.find('option:contains("' + v + '")');
        if ($byBody.length > 0) {
          $this.val($byBody.attr('value'));
        }
      }
    });
  }
  buttons();
  radioValue();
  selectValue();
}
